import { render, staticRenderFns } from "./ChatsMessageTags.vue?vue&type=template&id=5bdc5c5c"
import script from "./ChatsMessageTags.vue?vue&type=script&lang=js"
export * from "./ChatsMessageTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports